<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <div class="bg-white p-10 text-justify">
        <div v-html="title" class="text-xl font-bold text-center" />
        <div v-html="content" class="my-4" />
        <div class="md:flex mr-2 mt-10">
          <v-btn text @click="submit($route.path, false)">No</v-btn>
          <v-btn @click="submit('customer-dashboard', true)" color="blue"
            >Yes</v-btn
          >
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import SecureStorage from "../utils/secureStorage";
export default {
  watch: {
    showAlert: {
      handler(e) {
        this.dialog = e;
      },
      immediate: true,
    },
  },
  props: ["showAlert", "props_data"],
  data() {
    return {
      message: "",
      dialog: false,
      title: "NOTIFICATION",
      content:
        "By submitting my request, I understand that my request will be subject for Management approval and there may be processing fees charged upon approval of my request. I also understand that my original payment terms and other conditions of my account initially agreed upon shall be in effect until I am otherwise notified of the terms of the approval of my request from the Website – Moldex Buyers Portal or through e-mail notification from Customer Service Department.",
    };
  },
  methods: {
    axiosInsert() {
      let data = {
        user_id: SecureStorage.getItem("auth").userId,
        status_id: this.props_data.status_id,
        remarks_id: this.props_data.remarks_id,
        classification_id: this.props_data.classification_id,
        department_id: this.props_data.department_id,
        subject: this.props_data.subject,
        remarks: "Your request is in process",
        request_type_id: this.props_data.request_type_id,
        email: SecureStorage.getItem("auth").email,
      };

      // Validation to ensure data is not null or empty
      for (let key in data) {
        if (!data[key]) {
          this.message = "Try again, system data is currently unavailable";
          return;
        }
      }

      axios
        .post("/tickets/add", data)
        .then((res) => {
          this.message = res.data;
        })
        .catch((err) => console.log(err));
    },
    submit(name, boolean) {
      if (boolean) {
        this.axiosInsert();
        this.$emit("alertDialogSubmit", name, boolean);
      } else {
        this.$emit("alertDialogSubmit", name, boolean);
      }
    },
  },
  mounted() {
    console.log("Parent Component:", this.$parent.$options.name);
  },
};
</script>
